var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAeg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200.9 370.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #94aacb;\n      }\n\n      .st0, .st1 {\n        fill-rule: evenodd;\n      }\n\n      .st1 {\n        fill: #00217a;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1147,185.4h43.2c-22.9-11-41.5-28.9-52.9-50.9-18.9-36.2-55.5-56.9-103-61.3l1.1,3.2c32.9,12.7,55.6,32.7,68.8,61h0c9.3,19.6,24.2,36.2,42.8,48Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1147,185.4h43.2c-22.9,11-41.5,28.9-52.9,50.9h0c-18.9,36.2-55.5,56.9-103,61.3l1.1-3.2c32.9-12.7,55.6-32.7,68.8-61h0c9.3-19.6,24.2-36.2,42.8-48Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1034.3,109.6c7.8,27.8,18.4,50.9,27.7,62.1h0c4.8,5.9,11,10.6,18.2,13.6h34.1c-16.1-6.8-29-19.2-36.1-34.5h0c-8.5-18.6-24.3-33.4-43.9-41.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1034.3,261.2c7.8-27.8,18.4-50.9,27.7-62.1h0c4.8-5.9,11-10.6,18.2-13.6h34.1c-16.1,6.8-29,19.2-36.1,34.5h0c-8.5,18.6-24.3,33.4-43.9,41.3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M302.4,238.4l3.6-18.6h-93.8v-23.5h74.7s0,0,0,0v-21.7h-74.8v-23.5h84.2c2.1,0,3.8-1.4,4.1-3.4l3.3-18.3h-114c-2.1,0-3.9,1.7-3.9,3.7v108.5h112.6c1.9,0,3.5-1.3,3.8-3.1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M618.3,238.4l3.6-18.6h-93.8v-23.5h74.7s0,0,0,0v-21.7h-74.8v-23.5h84.2c2.1,0,3.8-1.4,4.1-3.4l3.3-18.3h-114c-2.1,0-3.9,1.7-3.9,3.7v108.5h112.6c1.9,0,3.5-1.3,3.8-3.1Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M841.1,162.6l82.4,75.9c2.1,1.9,4.8,3,7.6,3h19.1v-112.2h-21.5c-2.3,0-4.1,1.7-4.1,3.9v72.1l-79.6-73.2c-2-1.8-4.5-2.7-7.2-2.7h-23v112.2h26.1v-78.9Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.7,220.9c1.2-2.3,3.7-3.8,6.4-3.8h63.3l11.3,20.8c1.2,2.2,3.5,3.5,6.1,3.5h25.7l-58.9-107.7c-1.5-2.8-4.6-4.5-7.8-4.5h-24.7L10.6,241.5h28.8l11.3-20.6ZM86.7,155.2l21.9,40.3h-44l22.1-40.3Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M678.5,220.9c1.2-2.3,3.7-3.8,6.4-3.8h63.3l11.3,20.8c1.2,2.2,3.5,3.5,6.1,3.5h25.7l-58.9-107.7c-1.5-2.8-4.5-4.5-7.8-4.5h-24.7l-61.4,112.2h28.8l11.3-20.6ZM714.4,155.2l21.9,40.3h-44l22-40.3Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M467.1,227.8v-49.5h-49.5v18.2c0,1.9,1.7,3.5,3.7,3.5h19.5v14.7c-6.7,4.6-22.9,7.8-39.9,7.8-27.4,0-44.7-14-44.4-36.7.3-22.5,17.5-36.5,44.5-36.5s35.7,4.1,51,12.3l11.7-21c-31.9-15.2-59.8-14.3-62.6-14.3-42,0-71.4,24.5-71.4,59.5s28,59.6,69.7,59.6,67.7-17.7,67.7-17.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAeg);
export default __webpack_public_path__ + "static/media/aeg.6fb58f698d1658f972a072cbb861eb46.svg";
export { ForwardRef as ReactComponent };